import type { ButtonHTMLAttributes } from 'react'
import { cn } from '@/lib/cn'

export interface SwitchProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'onChange'> {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  label?: string
  compact?: boolean
}

export function Switch({ checked, onCheckedChange, label, compact = false, className, ...props }: SwitchProps) {
  return (
    <button {...props} type="button" role="switch" aria-checked={checked}
      onClick={() => onCheckedChange(!checked)}
      className={cn('inline-flex min-h-11 min-w-11 shrink-0 items-center justify-center gap-2 rounded-lg text-xs text-text-muted disabled:pointer-events-none disabled:opacity-50', className)}>
      {label}
      <span aria-hidden="true" className={cn('relative block shrink-0 rounded-full border transition-colors', compact ? 'h-5 w-9' : 'h-6 w-11', checked ? 'border-accent bg-accent' : 'border-border-strong bg-surface-hover')}>
        <span className={cn('absolute left-0.5 top-0.5 rounded-full bg-white shadow-sm transition-transform', compact ? 'h-3.5 w-3.5' : 'h-[1.125rem] w-[1.125rem]', checked && (compact ? 'translate-x-4' : 'translate-x-5'))} />
      </span>
    </button>
  )
}
